//ログインページ /lpLogin
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import users from './store/user'
import './css/lpLogin.css';
import {browserHistory} from 'react-router';
import { login, emailLogin } from './firebase';
import ToggleDisplay from 'react-toggle-display';
import { Link } from 'react-router'
import Recaptcha from 'react-recaptcha';
import define from './define';

let recaptchaInstance;

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailInvalid: false,
      errorMessage: '',
    }
  }

  loginStart(e){
    login(() => {
      if(users.getMyUser().uid){
        browserHistory.push("/user/" + users.getMyUser().uid);          
      }
    })
  }

  async handleEmailLogin(e) {
    e.preventDefault();
    const email = this.state.email;
    const password = this.state.password;

    if (undefined === email || 0 === email.length) {
      this.setState({ errorMessage: '※メールアドレスを入力してください' });
      this.setState({ emailInvalid: true });
      return;
    } else if (undefined === password || 0 === password.length) {
      this.setState({ errorMessage: '※パスワードを入力してください' });
      this.setState({ emailInvalid: true });
      return;
    }

    try {
      // login
      await emailLogin(email, password, () => {
        if (users.getMyUser().uid) {
          browserHistory.push("/user/" + users.getMyUser().uid);          
        }
      });
    } catch (errorCode) {
      // login error
      if ('auth/wrong-password' === errorCode) {
        this.setState({ errorMessage: '※メールアドレスまたはパスワードが間違っています'})
        this.setState({ emailInvalid: true });
      } else if ('auth/user-not-found' === errorCode) {
        this.setState({ errorMessage: '※メールアドレスまたはパスワードが間違っています'})
        this.setState({ emailInvalid: true });
      } else if ('auth/invalid-email' === errorCode) {
        this.setState({ errorMessage: '※正しいメールアドレスを入力してください'})
        this.setState({ emailInvalid: true });
      }
      return;
    }
  }

  handleEmailChange(e) {
    this.setState({email: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  verifyCallback = token => {
    const url = `/api/verifyRecaptchaToken?response=${token}`

    fetch(url)
      .then(res => {
        return res.json()
      })
      .then(data => {
        if (!data.error) {
          // make login button clickable
          const el = document.getElementById('recaptcha-button');
          el.classList.remove('disabled');
          el.removeAttribute('disabled');
          return
        }
        // reCAPTCHAのチェックボックスのチェックを外す
        recaptchaInstance.reset()
      })
  }

  render() {
    return (
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-login">
        <Header />
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-login">
                  <h2 className="subtitle-en">Login</h2>
                  <div className="">
                    <form className="form-login">
                      <button className="submit" type="button" onClick={(e) => {this.loginStart(e)}}><span className="fb-button">Facebookでログインする</span></button>
                    </form>

                    <hr />

                    <form className="form-login" onSubmit={(e) => {this.handleEmailLogin(e)}}>
                    <ToggleDisplay if={this.state.emailInvalid}>
                      <p>{this.state.errorMessage}</p>
                    </ToggleDisplay>
                      <input type="text" name="email" value={this.state.email} onChange={(e) => this.handleEmailChange(e)} placeholder="メールアドレスを入力ください"></input>
                      <input type="password" name="password" value={this.state.password} onChange={(e) => this.handlePasswordChange(e)} placeholder="パスワードを入力ください"></input>
                      <Link to={'/password_reset1'}>パスワードをお忘れの方はこちら</Link>
                      
                      <Recaptcha
                        ref={e => recaptchaInstance = e}
                        sitekey={define.RECAPTCHA_CONFIG.siteKey}
                        size="normal"
                        render="explicit"
                        verifyCallback={this.verifyCallback}
                        badge='inline'
                        hl='ja'
                        onloadCallback={() => {}}
                      />

                      <button id="recaptcha-button" className="recaptcha submit disabled" disabled={true} type="submit"><span className="mail-button">メールアドレスでログインする</span></button>
                    </form>

                  </div>
                </div>
              </div>

            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/lpLogin.js